import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import Icon from 'components/common/icon'
import { ICON_SIZE } from 'components/common/icon/const'

const PomeloPickUpStep = ({ step, t }) => (
  <div className="pdp__pickup-modal__step">
    <div className="pdp__pickup-modal__step-icon">
      <Icon src={step.icon} size={ICON_SIZE.large} />
    </div>
    <div className="pdp__pickup-modal__step-info">
      <span className={clsx('pdp__pickup-modal__step-title', Typo.subtitle2)}>
        {hasLocizeTranslation(t, step.title.key, step.title.val)}
      </span>
      <span className={clsx('pdp__pickup-modal__step-desc', Typo.body2)}>
        {hasLocizeTranslation(t, step.description.key, step.description.val)}
      </span>
    </div>
  </div>
)

PomeloPickUpStep.propTypes = {
  step: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.shape({
      key: PropTypes.string.isRequired,
      val: PropTypes.string.isRequired,
    }),
    description: PropTypes.shape({
      key: PropTypes.string.isRequired,
      val: PropTypes.string.isRequired,
    }),
  }).isRequired,
  t: PropTypes.func.isRequired,
}

const Extended = withI18next()(PomeloPickUpStep)

export default Extended
